import http from "./http-common";
class CommonService {
    async authenticateWithCompany(username, password, company) {
        var model = {
            Username: username,
            Password: password,
            SelectedCompanyId: company,
        }
        const response = await http.post("/Login/AuthenticateWithCompany", JSON.stringify(model));
        return response.data;
    }
}

export default new CommonService();
